import { useSiteContent } from "../../lib/siteContent";

export default function TickerBanner() {
  const site = useSiteContent();
  const ticker = site.ticker || {};
  const text = (ticker.text || "").trim();
  if (ticker.enabled === false || !text) return null;
  const loop = `${text}   ·   ${text}   ·   ${text}   ·   `;
  return (
    <div
      data-testid="ticker-banner"
      className="fixed left-0 right-0 z-40 overflow-hidden bg-[#311b52] text-white h-9 flex items-center"
      style={{ top: "var(--bmj-nav-h, 88px)" }}
    >
      <div className="whitespace-nowrap text-xs font-medium tracking-wide animate-[bmj-marquee_28s_linear_infinite]" style={{ fontFamily: "Montserrat, sans-serif" }}>
        {loop}{loop}
      </div>
      <style>{`@keyframes bmj-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </div>
  );
}

export function tickerOffset(site) {
  const ticker = site?.ticker || {};
  return ticker.enabled === false || !(ticker.text || "").trim() ? 0 : 36;
}
